/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * a Organisation
 * @export
 * @interface ApiOrganisation
 */
export interface ApiOrganisation {
    /**
     * 
     * @type {number}
     * @memberof ApiOrganisation
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiOrganisation
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiOrganisation
     */
    inactive?: boolean;
    /**
     * 
     * @type {ApiOrganisationCurrencyEnum}
     * @memberof ApiOrganisation
     */
    currency: ApiOrganisationCurrencyEnum;
    /**
     * 
     * @type {Date}
     * @memberof ApiOrganisation
     */
    readonly createdTime?: Date;
}

/**
* @export
* @enum {string}
*/
export enum ApiOrganisationCurrencyEnum {
    EUR = 'EUR',
    GBP = 'GBP',
    USD = 'USD',
    KES = 'KES',
    UGX = 'UGX',
    ALL = 'ALL',
    KZT = 'KZT',
    HKD = 'HKD'
}


/**
 * Check if a given object implements the ApiOrganisation interface.
 */
export function instanceOfApiOrganisation(value: object): value is ApiOrganisation {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    return true;
}

export function ApiOrganisationFromJSON(json: any): ApiOrganisation {
    return ApiOrganisationFromJSONTyped(json, false);
}

export function ApiOrganisationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiOrganisation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'inactive': json['inactive'] == null ? undefined : json['inactive'],
        'currency': json['currency'],
        'createdTime': json['createdTime'] == null ? undefined : (new Date(json['createdTime'])),
    };
}

export function ApiOrganisationToJSON(json: any): ApiOrganisation {
    return ApiOrganisationToJSONTyped(json, false);
}

export function ApiOrganisationToJSONTyped(value?: Omit<ApiOrganisation, 'createdTime'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'inactive': value['inactive'],
        'currency': value['currency'],
    };
}

